import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios, {AxiosResponse} from "axios";
import Cookies from 'js-cookie'
import {AppDispatch, RootState} from "../store";
import {instance, pathname} from "store/reducers/ActionCreators";

type AuthState = {
    email: string
    password: string
    loading: boolean
    loggedIn: boolean
}

type Response = {
    refresh: string
    access: string
}

const initialState: AuthState = {
    email: '',
    password: '',
    loading: false,
    loggedIn: false
}

export const getAuthentication: any = createAsyncThunk<Response,
    void,
    { state: RootState, dispatch: AppDispatch }>
('get/auth',
    async (_, {getState, rejectWithValue}) => {
        const {auth} = getState()
        const {email, password} = auth
        try {
            const response: AxiosResponse = await instance.post(pathname + '/api/auth',
                {username: email, password}
            )
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        } finally {
            // thunkAPI.dispatch(resetState())
        }
    }
)

const authSlice = createSlice({
    name: 'AuthSlice',
    initialState,
    reducers: {
        resetState: () => initialState,
        logOut(state) {
            state.loggedIn = false
        },
        logIn(state) {
            state.loggedIn = true
        },
        resetPassword(state) {
            state.password = ""
        },
        setEmail(state, action) {
            state.email = action.payload
        },
        setPassword(state, action) {
            state.password = action.payload
        },
    },
    extraReducers: {
        [getAuthentication.fulfilled.type]: (state, action) => {
            console.log('access',state,action);
            
            const {access} = action?.payload
            Cookies.set('access', access)
            state.loading = false
            state.loggedIn = true
        },
        [getAuthentication.pending.type]: (state) => {
            state.loading = true
        },
        [getAuthentication.rejected.type]: (state) => {
            state.password = ""
            state.loading = false
        }
    }
});

export const {setEmail, setPassword, resetState, resetPassword, logOut, logIn} = authSlice.actions

export default authSlice.reducer;
